import { TripBoxes } from '../../components/tripBoxes';
import { LoadingTripBoxes } from '../../components/loadingTripBoxes';
import { TransformedTrip } from '../../hooks/myTrips/useMyTripsData';
import { EmptyTripsState } from './EmptyTripsState';

interface MyTripsGridProps {
  trips?: TransformedTrip[];
  isLoading: boolean;
  hasTrips: boolean;
  onCreateTrip: () => void;
}

/**
 * Main content area for My Trips page - displays trip grid or empty state.
 */
export const MyTripsGrid = ({ trips, isLoading, hasTrips, onCreateTrip }: MyTripsGridProps) => {
  return (
    <div className="-mt-32 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-12">
      <div className="rounded-3xl bg-surface p-6 shadow-xl sm:p-10 min-h-[500px]">
        {trips && <TripBoxes trips={trips} useReactNavigation={true} />}

        {!trips && isLoading && <LoadingTripBoxes />}

        {!hasTrips && !isLoading && <EmptyTripsState onCreateTrip={onCreateTrip} />}
      </div>
    </div>
  );
};
